import React from 'react';
import type { ICellRendererParams } from 'ag-grid-community';

interface DamageCountViewProps {
  value?: number | string | null;
}

type DamageCountViewInput = DamageCountViewProps | ICellRendererParams;

const resolveDamageCount = (input: DamageCountViewInput): number => {
  return Number(input.value ?? 0);
};

const isGridRendererInput = (input: DamageCountViewInput): input is ICellRendererParams => {
  return 'node' in input && 'api' in input;
};

export default function DamageCountView(input: DamageCountViewInput) {
  const value = resolveDamageCount(input);
  const containerClassName = isGridRendererInput(input) ? 'mt-2 cursor-default' : 'cursor-default';

  return (
    <div className={containerClassName}>
      <span
        className={`flex cursor-default items-center justify-center w-[20px] h-[20px] rounded-[5px] ${value > 0 ? 'bg-red-500' : 'bg-green-500'} mx-auto text-white text-[12px]`}>
        {value > 0 ? value : 0}
      </span>
    </div>
  );
}
